import React, { Component } from "react";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { bindActionCreators } from "redux";
import { Button, Modal, Image, Form } from "react-bootstrap";
import { get } from "lodash";
import {
  getSearchInputData,
  resetSearchInputData
} from "../../../actions/common.action";
import {
  clearUsersListDownloadAction,
  deleteGroupAction,
  getDownloadUsersListAction,
  getGroupsForUserAction,
  getGroupsListAction,
  getBestPracticesList,
  getBestPracticesCount,
  migrateProjectAction,
  deleteBestPracticeAction
} from "../../../actions/userManagement.action";
import { LoaderPage } from "../../../component/Loader";
import { PopUpModel } from "../../../component/PopUp";
import { STATUS } from "../../../constant";
import { isValidArray } from "../../../helper";
import Pagination from "../../Pagination";
import PermissionHOC from "../../PermissionHOC";
import {
  ModalComponent,
  ModalTemplate,
  Search,
  TableTemplate
} from "../../reusableComponent";
import { PAGE_COUNT } from "../helper";
import { bestPracticesHeader } from "../usermangement.constant";
import CreateBestPracticeForm from "./createBestPractices.Form";
import CreateBestPracticeEditForm from "./createBestPracticeEdit.Form";
import { MigrateProjectComponent } from "../users/migrateProjectComponent";
import CreateBestPractices from "../../../assets/best-practices-icon.svg";
import EditImage from "../../../assets/edit-image.svg";
import DeleteImage from "../../../assets/delete-image.svg";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ConfirmationComponent } from "../../ConfirmationComponent";
import { getGroupsByCategoryAction } from "../../../actions/createProject.action";
import { event } from "jquery";
import { dateFormat } from "../../../helper";
import { successToastStyle, errorToastStyle } from "../../../customToast";

const Params = {
  limit: 10,
  offset: 0,
  search: "",
  groupId: ""
};

class BestPractices extends Component {
  constructor(props) {
    super(props);
    this.practiceModelRef = React.createRef();
    this.state = {
      paginationoffset: 0,
      filteredArray: [],
      noFilterData: false,
      searchInputData: "",
      showBubbleFilter: false,
      selectedFilter: null,
      makeSelectedNull: false,
      bestPracticesList: null,
      bestPracticesPagination: { ...Params },
      isUserActive: true,
      displayModal: false,
      bestPracticesTotalCount: 0,
      showAlert: false,
      bestPracticeId: 0,
      groupData: [],
      category: ["CENTRAL", "PMG"]
    };
  }

  componentDidMount() {
    const {
      getBestPracticesListDispatch,
      getBestPracticesCountDispatch,
      getGroupsByCategoryActionDispatch
    } = this.props;
    const { bestPracticesList, bestPracticesPagination, category } = this.state;
    getBestPracticesCountDispatch(
      undefined,
      this.state.bestPracticesPagination
    ).then(res => {
      this.setState({
        bestPracticesTotalCount: res.data
      });
    });
    getGroupsByCategoryActionDispatch(undefined, {
      category: ["CENTRAL", "PMG"]
    }).then(res => {
      this.setState({
        ministryData: res
      });
    });
    const response = getBestPracticesListDispatch(
      undefined,
      bestPracticesPagination
    );
    if (response) {
      getBestPracticesListDispatch(undefined, bestPracticesPagination).then(
        res => {
          this.setState({
            bestPracticesList: res.data
          });
        }
      );
    }
  }

  onToggleModal = value => {
    this.setState(prevState => ({
      displayModal: !prevState.displayModal
    }));
  };

  onEdit = value => {
    const isEdit = this.state.isEdit;
    this.setState({
      isEdit: !isEdit,
      groupData: (!isEdit && value) || null
    });
  };

  onDeleteAlertToggle = value => {
    const displayDeleteAlert = this.state.displayDeleteAlert;
    this.setState({
      displayDeleteAlert: !displayDeleteAlert,
      deleteData: (!displayDeleteAlert && value) || null
    });
  };

  onSubmit = async () => {
    const { deleteBestPractice } = this.props;
    const { bestPracticeId } = this.state;
    const deleteResponse = await deleteBestPractice(undefined, bestPracticeId);
    this.callApiOnSuccess();
    if (deleteResponse) {
      this.openConfirmationAlert();
      toast.success(
        <p className="toast-text-alignment">{deleteResponse.message}</p>,
        successToastStyle
      );
    } else {
      toast.error(
        <p className="toast-text-alignment">{deleteResponse.message}</p>,
        errorToastStyle
      );
    }
  };

  openConfirmationAlert = () => {
    this.setState(prevState => ({
      showAlert: !prevState.showAlert
    }));
  };

  onDelete = event => {
    this.setState({
      bestPracticeId: event.id
    });
    this.openConfirmationAlert();
  };

  getFilterId = (id, elem) => {
    const {
      getBestPracticesListDispatch,
      getBestPracticesCountDispatch
    } = this.props;

    if (id === 0) {
      this.removeFilter();
    } else {
      this.setState(
        prevState => ({
          paginationoffset: 0,
          showBubbleFilter: true,
          selectedFilter: elem,
          makeSelectedNull: false,
          bestPracticesPagination: {
            ...prevState.bestPracticesPagination,
            offset: 0,
            groupId: id
          }
        }),
        () => {
          getBestPracticesCountDispatch(
            undefined,
            this.state.bestPracticesPagination
          ).then(res => {
            this.setState({
              bestPracticesTotalCount: res.data
            });
          });

          getBestPracticesListDispatch(
            undefined,
            this.state.bestPracticesPagination
          ).then(res => {
            {
            }
            this.setState({
              bestPracticesList: res.data
            });
          });
        }
      );
    }
  };

  removeFilter = () => {
    const {
      getBestPracticesListDispatch,
      getBestPracticesCountDispatch
    } = this.props;
    this.setState(
      prevState => ({
        paginationoffset: 0,
        showBubbleFilter: false,
        selectedFilter: null,
        makeSelectedNull: true,
        bestPracticesPagination: {
          ...prevState.bestPracticesPagination,
          offset: 0,
          groupId: ""
        }
      }),
      () => {
        getBestPracticesListDispatch(
          undefined,
          this.state.bestPracticesPagination
        ).then(res => {
          this.setState({
            bestPracticesList: res.data
          });
        });

        getBestPracticesCountDispatch(
          undefined,
          this.state.bestPracticesPagination
        ).then(res => {
          this.setState({
            bestPracticesTotalCount: res.data
          });
        });
      }
    );
  };

  onPageChange = page => {
    const { getBestPracticesListDispatch } = this.props;
    this.setState(
      prevState => ({
        paginationoffset: page.selected || 0,
        bestPracticesPagination: {
          ...prevState.bestPracticesPagination,
          offset: page.selected || 0,
          limit: PAGE_COUNT
        }
      }),
      () => {
        getBestPracticesListDispatch(
          undefined,
          this.state.bestPracticesPagination
        ).then(res => {
          this.setState({
            bestPracticesList: res.data
          });
        });
      }
    );
  };

  callApiOnSuccess = () => {
    const {
      getBestPracticesListDispatch,
      getBestPracticesCountDispatch
    } = this.props;
    getBestPracticesCountDispatch(
      undefined,
      this.state.bestPracticesPagination
    ).then(res => {
      this.setState({
        bestPracticesTotalCount: res.data
      });
    });
    getBestPracticesListDispatch(
      undefined,
      this.state.bestPracticesPagination
    ).then(res => {
      this.setState({
        bestPracticesList: res.data
      });
    });
  };

  onSearch = (e, values) => {
    const { name, value } = values;
    this.setState(prevState => ({
      paginationoffset: 0,
      bestPracticesPagination: {
        ...prevState.bestPracticesPagination,
        offset: 0,
        [name]: value
      }
    }));
  };

  callAfterDebounce = () => {
    const {
      getBestPracticesListDispatch,
      getBestPracticesCountDispatch
    } = this.props;
    this.setState(
      {
        isSearching: true
      },
      async () => {
        await getBestPracticesListDispatch(
          undefined,
          this.state.bestPracticesPagination
        ).then(res => {
          this.setState({
            bestPracticesList: res.data
          });
        });
        this.setState({
          isSearching: false
        });

        getBestPracticesCountDispatch(
          undefined,
          this.state.bestPracticesPagination
        ).then(res => {
          this.setState({
            bestPracticesTotalCount: res.data
          });
        });
      }
    );
  };

  onToggleMigrateModal = () => {
    this.setState(prevState => ({
      toggleMigrateModal: !prevState.toggleMigrateModal
    }));
  };

  render() {
    const {
      onSearch,
      callAfterDebounce,
      onToggleMigrateModal,
      onSubmitMigrateProject
    } = this;

    const {
      isBestPracticesLoading,
      permission,
      isProjectMigrating
    } = this.props;
    const {
      displayModal,
      isEdit,
      groupData,
      displayDeleteAlert,
      filteredArray,
      isFilterApplied,
      isSearching,
      toggleMigrateModal,
      paginationoffset,
      showBubbleFilter,
      selectedFilter,
      makeSelectedNull,
      bestPracticesList,
      bestPracticesTotalCount,
      showAlert,
      bestPracticesPagination,
      ministryData
    } = this.state;
    if (isValidArray(get(bestPracticesList, "data.userDTOList"))) {
      const listData = bestPracticesList.data.userDTOList;
      let groupList = isFilterApplied ? filteredArray : listData;
      if (bestPracticesList.search) {
        groupList = [];
        listData.forEach(group => {
          if (
            group.name
              .toLowerCase()
              .includes(bestPracticesList.search.toLowerCase())
          ) {
            groupList.push(group);
          }
        });
      }
    }
    //Filter list based on category
    let filterList = [{ id: 0, name: "Reset All" }];
    if (isValidArray(get(ministryData, "data"))) {
      ministryData.data.forEach(elem => {
        filterList.push(elem);
      });
    }

    return (
      <div className="group-management users-listing">
        <LoaderPage loading={isProjectMigrating} />
        {toggleMigrateModal ? (
          <ModalComponent
            centered
            classes="migrate_modal"
            onClose={onToggleMigrateModal}
            size={"lg"}
            template={
              <ModalTemplate
                bodyTemplate={<MigrateProjectComponent />}
                onClose={onToggleMigrateModal}
                onSubmitTitle="Migrate"
                onSubmit={onSubmitMigrateProject}
              />
            }
          />
        ) : null}

        <ConfirmationComponent
          show={showAlert}
          modalClass={"confirmation-modal best-practices"}
          saveHandler={this.onSubmit}
          content={"Are you sure you want to delete this practice?"}
          closeHandler={this.openConfirmationAlert}
        />

        <div className="header ">
          <div className="d-flex flex-row">
            <h3>
              Best Practices{" "}
              {bestPracticesTotalCount !== 0 ? (
                <span style={{ verticalAlign: "middle" }}>
                  ({bestPracticesTotalCount})
                </span>
              ) : (
                ""
              )}
            </h3>
          </div>
          <div className="header-buttons d-flex flex-row">
            <div className="issue-list-exposed-filters search-in-user pb-2 pr-4">
              <div className="issue-list-filter-right">
                <div className="filters-sections">
                  <Search
                    placeholder="Search"
                    keyName="search"
                    onChange={onSearch}
                    value={bestPracticesPagination.search}
                    isLoading={isSearching}
                    callAfterDebounce={callAfterDebounce}
                    isSearchingBestPractice={true}
                    filterList={filterList}
                    getFilterId={this.getFilterId}
                    makeSelectedNull={makeSelectedNull}
                  />
                </div>
              </div>
            </div>
            <OverlayTrigger
              trigger="hover"
              defaultShow={false}
              placement="bottom"
              overlay={
                <Tooltip
                  id={`tooltip-checking`}
                  className="create_project_tolltip"
                >
                  Create New Practice
                </Tooltip>
              }
            >
              <Button
                className={`btn-orange create-btn ${
                  get(permission, "migrateProject") === true
                    ? "create-user-btn"
                    : ""
                }`}
                style={{
                  marginLeft:
                    window.location.pathname == "/user-management"
                      ? "0px"
                      : "inherit"
                }}
                size="sm"
                onClick={this.onToggleModal}
              >
                <div>
                  <Image src={CreateBestPractices} className="create-user" />
                </div>
              </Button>
            </OverlayTrigger>
          </div>
        </div>
        {/*  Edit Modal Start **/}

        <Modal
          size="lg"
          show={isEdit}
          onHide={this.onEdit}
          aria-labelledby="example-modal-sizes-title-lg"
          containerClass="edit-user-form"
          className="edit-user-modal-form"
        >
          <div className="modal-box-shadow" ref={this.practiceModelRef}>
            <Modal.Header closeButton className="header-modal">
              <Modal.Title id="example-modal-sizes-title-lg">
                Edit practice
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="body-modal">
              <CreateBestPracticeEditForm
                togglePopUp={this.onEdit}
                isEdit={isEdit}
                groupData={groupData}
                ministryData={ministryData}
                callApiOnSuccess={this.callApiOnSuccess}
                permission={permission}
                practiceModelRef={this.practiceModelRef}
              />
            </Modal.Body>
          </div>
        </Modal>
        {/*  Edit Modal End **/}

        {/*  Create Modal **/}
        <Modal
          size="lg"
          show={displayModal}
          onHide={this.onToggleModal}
          aria-labelledby="example-modal-sizes-title-lg"
          className="content-modal  create-user-form"
        >
          <div className="modal-box-shadow" ref={this.practiceModelRef}>
            <Modal.Header closeButton className="header-modal">
              <Modal.Title id="example-modal-sizes-title-lg">
                Create new practice
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="body-modal  create-user-body-modal">
              <CreateBestPracticeForm
                togglePopUp={this.onToggleModal}
                callApiOnSuccess={this.callApiOnSuccess}
                ministryData={ministryData}
                practiceModelRef={this.practiceModelRef}
              />
            </Modal.Body>
          </div>
        </Modal>
        {/*  Create Modal End **/}

        {/*  Delete Alert Pop Up **/}

        <PopUpModel
          open={displayDeleteAlert}
          text={"Are you sure you want to delete it?"}
          leftBtnText={"Yes"}
          rightBtnText={"No"}
          onCancel={this.onDeleteAlertToggle}
          onSubmit={this.onDelete}
        />
        {showBubbleFilter ? (
          <div className="applied-filter-list pt-3 mb-0">
            <div className="applied-filter mb-0">
              {selectedFilter && selectedFilter.name}
              <span
                className="close"
                onClick={e => {
                  this.removeFilter();
                }}
              >
                X
              </span>
            </div>
          </div>
        ) : null}
        <TableTemplate
          isUsersTable={true}
          isBestPracticesTable={true}
          headersOptions={bestPracticesHeader}
          isLoading={isBestPracticesLoading === STATUS.LOADING}
          bodyOptions={this.state.bestPracticesList}
          bodyTemplate={(options, index) => (
            <>
              <td>{options.organization}</td>
              <td className="pl-2">{options.title}</td>
              <td>
                <OverlayTrigger
                  trigger="hover"
                  defaultShow={false}
                  placement="bottom-start"
                  className="best-practices-tooltip"
                  overlay={
                    <Tooltip
                      arrow={true}
                      placement="bottom-start"
                      className="best-practices-tooltip"
                      id={`tooltip-${options.title}`}
                      style={{ cursor: "pointer" }}
                    >
                      {options.description}
                    </Tooltip>
                  }
                >
                  <div className="text-truncate" style={{ cursor: "pointer" }}>
                    {options.description}
                  </div>
                </OverlayTrigger>
              </td>
              <td>{dateFormat(options.createdDate)}</td>
              <td>
                <Image
                  className={"edit-image"}
                  src={EditImage}
                  onClick={this.onEdit.bind(this, options)}
                />
                <Image
                  className={"edit-image"}
                  style={{ paddingLeft: 11 }}
                  src={DeleteImage}
                  onClick={this.onDelete.bind(this, options)}
                />
              </td>
            </>
          )}
          headersTemplate={bestPracticesHeader => (
            <>
              <th>{bestPracticesHeader.title}</th>
            </>
          )}
        />

        {isBestPracticesLoading === STATUS.SUCCESS ? (
          <div className="pagination-wrapper">
            <div class="pagination pagination-in-user-listing">
              <Pagination
                offset={paginationoffset}
                pageCount={bestPracticesTotalCount / PAGE_COUNT}
                onPageChange={this.onPageChange}
              />
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    bestPracticesList: state.userManagementReducer.bestPracticesList,
    groups: state.userManagementReducer.groups,
    isBestPracticesLoading: state.userManagementReducer.isBestPracticesLoading,
    searchInput: state.commonReducer.searchInput,
    migrateFormData: state.userManagementReducer.migrateFormData,
    isProjectMigrating: state.userManagementReducer.isProjectMigrating,
    usersListDownload: state.userManagementReducer.usersListDownload
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getGroupsListDispatch: getGroupsListAction,
      deleteGroupDispatch: deleteGroupAction,
      deleteBestPractice: deleteBestPracticeAction,
      getBestPracticesListDispatch: getBestPracticesList,
      getBestPracticesCountDispatch: getBestPracticesCount,
      getGroupsByCategoryActionDispatch: getGroupsByCategoryAction,
      getSearchInputData: getSearchInputData,
      resetSearchInputData: resetSearchInputData,
      migrateProjectAction: migrateProjectAction,
      getGroupsForUserAction,
      getDownloadUsersListAction,
      clearUsersListDownloadAction
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PermissionHOC(BestPractices));
